export enum LogLevel {
  DEBUG,
  LOG,
  INFO,
  WARN,
  ERROR,
  OFF
}
